import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import TerritoryDialog from './dialogs/TerritoryDialog';
import TerritoryArchiveDialog from './dialogs/TerritoryArchiveDialog';

const TerritoriesEditor = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { action0, actionId0, action1, actionId1, action2, actionId2 } = useParams();

  const [navigationDepth, setNavigationDepth] = useState(0);
  const [pathname, setPathname] = useState('');

  // navigation effect
  useEffect(() => {
    if (pathname === '') {
      // first call
    } else if (pathname.includes(location.pathname)) {
      setNavigationDepth((depth) => Math.max(0, depth - 1));
    } else {
      setNavigationDepth((depth) => depth + 1);
    }
    setPathname(location.pathname);
  }, [location]);

  const handleClose = () => {
    if (navigationDepth) {
      navigate(-1);
    } else if (actionId1 === 'territory') {
      navigate('../../../../', { replace: true });
    } else if (actionId2 || (!action2 && actionId1)) {
      navigate('../../', { replace: true });
    } else if (actionId1 || (!action1 && actionId0)) {
      navigate('../../', { replace: true });
    } else {
      navigate('../', { replace: true });
    }
  };

  return (
    <>
      <TerritoryDialog
        handleClose={() => handleClose()}
      />

      <TerritoryArchiveDialog
        handleClose={() => handleClose()}
      />
    </>
  );
};

export default TerritoriesEditor;
